// extracted by mini-css-extract-plugin
export default {"serverErrorMessage":"FormServerError__serverErrorMessage___uJLwq"};